import React, { useEffect, useState } from 'react';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
// core components
import { upload } from '../../store/actions/vendor/Vendor';
import { Table, Button } from 'reactstrap';
import { connect } from 'react-redux';
import {
  addRestaurantTypeAdmin,
  updateRestaurantType,
  getRestaurantTypeDetails
} from '../../store/actions/admin/Admin';
import CardHeader from '../../components/Card/CardHeader.js';
import CardBody from '../../components/Card/CardBody.js';
import CardFooter from '../../components/Card/CardFooter.js';
import GridItem from '../../components/Grid/GridItem.js';
import GridContainer from '../../components/Grid/GridContainer.js';
import CustomInput from '../../components/CustomInput/CustomInput.js';

const styles = {
  typo: {
    paddingLeft: '25%',
    marginBottom: '40px',
    position: 'relative'
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: '10px',
    color: '#c0c1c2',
    display: 'block',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '13px',
    left: '0',
    marginLeft: '20px',
    position: 'absolute',
    width: '260px'
  },
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  }
};

const useStyles = makeStyles(styles);

const AddRestaurantType = (props) => {
  const classes = useStyles();
  const [imageUploadMessage, updateImageUploadMessage] = useState('');
  const [typeData, updateData] = useState({
  });
  const [isEdit, updateIsEdit] = useState(false);

  const onChange = (event) => {
    let tempSuperCategory = { ...typeData };
    tempSuperCategory[event.target.name] = event.target.value;
    updateData(tempSuperCategory);
  };

  useEffect(() => {
    const RestaurantTypeId = props?.match?.params.id;
    if (RestaurantTypeId) {
      updateIsEdit(!!RestaurantTypeId);
      props.getRestaurantTypeDetails(RestaurantTypeId);
    }
  }, []);

  useEffect(() => {
    if (props?.restaurantTypeDetails && isEdit) {
      const restaurantType = {
        id: props.restaurantTypeDetails.id,
        name: props.restaurantTypeDetails.name,
        icon: props.restaurantTypeDetails.icon
      };
      updateData(restaurantType);
    }
  }, [props?.restaurantTypeDetails]);

  const onUpload = (event) => {
    updateImageUploadMessage('Uploading the file, please wait...');

    let data = new FormData();
    data.append('files', event.target.files[0]);
    props
      .upload(data)
      .then((response) => {
        if (response.status === 201) {
          updateImageUploadMessage('File uploaded successfully.');
          let tempSuperCategory = { ...typeData };
          tempSuperCategory.icon = `${response.data.uploads[0].path}`;
          updateData(tempSuperCategory);
        } else {
          updateImageUploadMessage('Please, try Again');
        }
      })
      .catch((error) => {
        updateImageUploadMessage(
          'An error occurred while executing the query. Please try Again'
        );
      });
  };
  const onSubmit = (event) => {
    event.preventDefault();
    if (isEdit) {
      let tempCategory = { ...typeData, restaurantTypeId: typeData.id };
      delete tempCategory.id 
      props.updateRestaurantType(tempCategory).then((data) => {
        if (data) {
          props.history.push('/admin/restaurant-type');
        }
      });
    } else {
      props.addRestaurantTypeAdmin(typeData).then((data) => {
        if (data) {
          props.history.push('/admin/restaurant-type');
        }
      });
    }
  };

  // const changeIsRestaurant = () => {
  //   const tempSuperCategory = { ...superCategory };
  //   tempSuperCategory.isResturant = !tempSuperCategory.isResturant;
  //   updateSuperCategory(tempSuperCategory);
  // };

  return (
    <>
      <CardHeader color="primary">
        <h4 className={classes.cardTitleWhite}>Add a Restaurant Type</h4>
        <p className={classes.cardCategoryWhite}>
          When choosing icon, PNG images would be better over JPG or imap
        </p>
      </CardHeader>
      <CardBody>
        <br />
        <GridContainer>
          <GridItem xs={12} sm={12} md={3}>
            <CustomInput
              labelText="Restaurant Type Name"
              value={typeData.name}
              onChange={onChange}
              name="name"
              id="name"
              // labelProps={{
              //   shrink: isEdit,
              // }}
              formControlProps={{
                fullWidth: true
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <CustomInput
              labelText="Restaurant Type Icon"
              id="icon"
              type="file"
              name="icon"
              accept="image/png, image/jpeg, image/jpg"
              onChange={onUpload}
              // labelProps={{
              //   shrink: isEdit,
              // }}
              formControlProps={{
                fullWidth: true
              }}
            />
          </GridItem>
          <br />
          <p style={{ color: '#000' }}>{imageUploadMessage}</p>
        </GridContainer>
      </CardBody>
      <CardFooter>
        <Button
          type="submit"
          onClick={onSubmit}
          style={{
            color: '#fff',
            backgroundColor: '#9c27b0',
            boxShadow:
              '0 2px 2px 0 rgba(156, 39, 176, 0.14), 0 3px 1px -2px rgba(156, 39, 176, 0.2), 0 1px 5px 0 rgba(156, 39, 176, 0.12)'
          }}
        >
          {/* {isEdit ? 'Update' : 'Edit'} Supercategory */}
          Add Restaurant Type
        </Button>
      </CardFooter>
      <br /> <br />
      <Table hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Icon</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>1</th>
            <td>{typeData.name}</td>
            <td>
              <img src={typeData.icon} style={{ height: '70px' }} alt="" />
            </td>
          </tr>
        </tbody>
      </Table>
    </>
  );
};

const mapStateWithProps = (state) => ({
  restaurantTypeDetails: state.admin.restaurantTypeDetails
});

const mapDispatchWithProps = (dispatch) => {
  return {
    getRestaurantTypeDetails: (RestaurantTypeId) =>
      dispatch(getRestaurantTypeDetails(RestaurantTypeId)),
    updateRestaurantType: (RestaurantTypeData) =>
      dispatch(updateRestaurantType(RestaurantTypeData)),
    addRestaurantTypeAdmin: (RestaurantTypeData) =>
      dispatch(addRestaurantTypeAdmin(RestaurantTypeData)),
    upload: (data) => dispatch(upload(data))
  };
};

export default connect(
  mapStateWithProps,
  mapDispatchWithProps
)(AddRestaurantType);
